<div class="page" [ngClass]="{'is-widget' : isWidget$ | async}">
  <div class="container container-lg no-container-widget">

    <app-breadcrumb></app-breadcrumb>

    <div class="wrapper-page wrapper-page--column" *ngIf="!noDetail">
      <!-- Header -->
      <div class="page-header order-2 order-lg-1">
        <app-detail-header [holidayDetails]="holidayDetails" [bookingUrl]="bookingUrl">
        </app-detail-header>
      </div>

      <!-- Gallery -->
      <div class="page-gallery order-1 order-lg-2">
        <app-detail-gallery [holidayDetails]="holidayDetails">
        </app-detail-gallery>
      </div>

      <div class="detail-tabs__container order-3">
        <app-detail-content-accomodation-tabs
          [holidayDetails]="holidayDetails"
          [selectedSolution]="selectedSolution">
        </app-detail-content-accomodation-tabs>
      </div>

      <!-- Main Content -->
      <div class="detail-container wrapper-page order-4 mt-4">

        <!-- Solution Descriptions -->
        <div class="detail-container__tabs wrapper-page__content order-2 order-lg-1">
          <div class="detail-content__container">
            <app-detail-content-accomodation
              [holidayDetails]="holidayDetails"
              [bookingUrl]="bookingUrl"
              [selectedSolution]="selectedSolution"
              [guestsAges]="guestsAges"
              [isLanding]="isLanding"></app-detail-content-accomodation>
          </div>
          <!-- [selectedDate]="selectedDate" -->
           <ng-container *ngIf="!this.showNoAvailabilityDetail && this.isLanding"> <!-- TODO capire quale condizione *ngIf serve mettere -->

            <detail-occupancy></detail-occupancy>

            <hr>

            <holiday-detailgeneric-page-date
            *ngIf="holidayDetails && holidayDetails.searchSolution"
              [searchSolution]="holidayDetails.searchSolution"
              [allAvailableDates]="this.allAvailableDates"></holiday-detailgeneric-page-date>

            <hr>

            <!-- Lista Soluzioni-->
            <section class="detail-content__section accomodation-tab__flights" id="solutionsList">
              <holiday-detail-generic-page-solutions
                *ngIf="allSolutionsToShow.length"

                [detailSolutions]="this.allSolutionsToShow"
                [formattedGuestsString]="this.formattedGuestsString"
                [allAvailableDates]="this.allAvailableDates">
              </holiday-detail-generic-page-solutions>
            </section>

          </ng-container>
        </div>

        <!-- Recap Aside -->
        <div class="detail-container__aside wrapper-page__aside order-1 order-lg-2">
          <div class="detail-recap__container"
          [ngClass]="{'detail-recap__container--fixed' : fixedRecap }">
            <app-detail-content-aside
              *ngIf="(holidayDetails && holidayDetails.searchSolution) || selectedSolution || showNoAvailabilityDetail"
              [noAvailability]="showNoAvailabilityDetail"
              [holidayDetails]="holidayDetails"
              [bookingUrl]="bookingUrl"
              [selectedSolution]="selectedSolution"
              [formattedGuestsString]="formattedGuestsString"
              [destinationName]="destinationName"
              [isLanding]="isLanding">
            </app-detail-content-aside>
          </div>
        </div>

      </div>

    </div>

    <!-- In caso di errore -->
    <div class="wrapper-page wrapper-page--column" *ngIf="noDetail">
      <div class="c-zero-results">
        <div class="c-zero-results__message">
          <h3>Il prodotto da te cercato non è più disponibile o è scaduto.</h3>
          <p *ngIf="!isLanding">
            Clicca <a href="javascript:void(0)" (click)="goToHomeRoute()">qui</a> per tornare all'homepage
          </p>
        </div>
        <div class="c-zero-results__image">
          <picture>
            <img src="./assets/images/no-results.svg" height="auto" width="auto" alt="No Results" loading="lazy">
          </picture>
        </div>
      </div>
    </div>

  </div>
</div>
